module.exports = __webpack_public_path__ + "img/500.f66cdf8a.svg";